import gql from 'graphql-tag';

export default gql`
  query CommunityProfileActive {
    viewer {
      id
      enabledFeatures
      profile {
        id
        field_activated_account
        field_account_consent
      }
    }
  }
`;
